import Badge, { type BadgeTone } from './Badge';

/** Maps the CPaaS status model + exception flags to a visual tone. */
const STATUS_TONES: Record<string, BadgeTone> = {
  // positive / settled
  Active: 'accent',
  Paid: 'accent',
  Completed: 'accent',
  Approved: 'accent',
  Contracted: 'accent',
  Accepted: 'accent',
  Connected: 'accent',
  Verified: 'accent',
  'KYC complete': 'accent',
  'Wallet active': 'accent',
  Signed: 'accent',

  // in motion
  Recruiting: 'secondary',
  Processing: 'secondary',
  Scheduled: 'secondary',
  'Payment Processing': 'secondary',
  'Contract Pending': 'secondary',
  Invited: 'secondary',
  Sent: 'secondary',
  'Partially Paid': 'secondary',
  Review: 'secondary',
  Paying: 'secondary',
  'Deliverable Submitted': 'secondary',
  'Pending review': 'secondary',
  'Awaiting approval': 'secondary',
  'Changes requested': 'primary',
  Viewed: 'neutral',

  // attention
  'Deadline at risk': 'primary',
  'Deadline missed': 'primary',
  'Revenue risk': 'primary',
  'Payout failed': 'primary',
  Failed: 'primary',
  Rejected: 'primary',
  Expired: 'primary',
  'KYC incomplete': 'primary',
  'Wallet inactive': 'primary',
  'Wallet frozen': 'primary',
  'Brief non-compliance': 'primary',
  'Budget exceeded': 'primary',
  'Engagement anomaly': 'primary',
  'Brand-safety signal': 'primary',
  'Deliverable missing': 'primary',
  'Duplicate creator': 'primary',
  'Rate mismatch': 'primary',
  'On hold': 'primary',
  Declined: 'primary',

  // neutral / early
  Draft: 'outline',
  Discovery: 'outline',
  Deactivated: 'outline',
  Cancelled: 'outline',
  Suspended: 'primary',
  Recommended: 'outline',
  Shortlisted: 'neutral',
  Pending: 'neutral',
  Archived: 'outline',
  'Not connected': 'outline',
  'Awaiting sync': 'outline',

  // Laravel creator lifecycle labels (CpaasCampaignCreator), as returned by the API
  'Link opened': 'neutral',
  'KYC done': 'accent',
  'Brief sent': 'secondary',
  Negotiating: 'secondary',
  'Contract pending': 'secondary',
  'Content submitted': 'secondary',
  'Revision needed': 'primary',
  'Content approved': 'accent',
  Payable: 'secondary',
  Removed: 'outline',
};

export default function StatusBadge({
  status,
  className = '',
}: {
  status: string;
  className?: string;
}) {
  const tone = STATUS_TONES[status] ?? 'neutral';
  // Things happening right now get a breathing dot.
  const live = LIVE_STATUSES.has(status);
  return (
    <Badge tone={tone} className={className}>
      {live ? <span className="live-dot h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" /> : null}
      {status}
    </Badge>
  );
}

const LIVE_STATUSES = new Set(['Active', 'Recruiting', 'Processing', 'Payment Processing', 'Paying']);